import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";

export function ForcePasswordChange() {
  const { refresh, logout } = useAuth();
  const [pw, setPw] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.new_password.length < 12) return toast.error("New password must be at least 12 characters");
    if (pw.new_password !== pw.confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: pw.current_password, new_password: pw.new_password });
      toast.success("Password changed");
      await refresh();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const field = (key, label) => (
    <Input data-testid={`force-${key}`} type="password" placeholder={label} value={pw[key]}
      onChange={(e) => setPw({ ...pw, [key]: e.target.value })} className="bg-[var(--bg-canvas)] border-[var(--border-subtle)]" />
  );
  return (
    <div data-testid="force-password-change" className="min-h-screen flex items-center justify-center bg-[var(--bg-canvas)] p-4">
      <form onSubmit={submit} className="w-full max-w-sm space-y-3 rounded-lg border border-[var(--border-subtle)] p-6">
        <h1 className="text-lg font-semibold text-slate-100 flex items-center gap-2"><KeyRound className="w-5 h-5" /> Set your own password</h1>
        <p className="text-xs text-slate-400">This account was created from deployment secrets. Choose a new password (12+ characters) before continuing, then enable MFA in Settings.</p>
        {field("current_password", "Current (provisioned) password")}
        {field("new_password", "New password")}
        {field("confirm", "Confirm new password")}
        <Button data-testid="force-submit" type="submit" disabled={busy} className="w-full bg-blue-600 hover:bg-blue-500 text-white">Update password</Button>
        <button type="button" data-testid="force-logout" onClick={logout} className="w-full text-xs text-slate-500 hover:text-slate-300">Sign out</button>
      </form>
    </div>
  );
}
